import React, { useCallback } from 'react'
import classNames from 'classnames'

import VerticalGroup from '../../../../../atoms/verticalgroup/VerticalGroup'
import Button from '../../../../../atoms/button/Button'
import BrandingPreview from '../../../../../organisms/brandingpreview/BrandingPreview'

interface BrandingSelectOptionProps {
  branding: API.BrandingResponse
  onBrandingSelected: (branding: API.BrandingResponse) => void
  'data-test'?: string
}
const BrandingSelectOption: React.FC<BrandingSelectOptionProps> = ({
  branding,
  onBrandingSelected,
  ...props
}) => {
  const onClick = useCallback(() => {
    onBrandingSelected(branding)
  }, [onBrandingSelected, branding])

  return <VerticalGroup 
    className={classNames('branding-select-option')}
  >
    <BrandingPreview
      branding={branding}
      maxContainerHeight={195}
    />
    <VerticalGroup center verticalCenter wide flexAuto>
      <Button
        data-test={props['data-test']}
        onClick={onClick}>Select</Button>
    </VerticalGroup>
  </VerticalGroup>
}

export default BrandingSelectOption
